import React from 'react';
import { useState, useContext } from 'react';
import { useParams } from 'react-router-dom';

import EditorTab from './EditorTab/EditorTab';
import TableTab from './TableTab';
import PreviewTab from './PreviewTab';
import ExportTab from './ExportTab';
import Loader from '../common/Loader';
import FormEditParams from '../FormEditParams';
import FormEditAssets from '../FormEditAssets';

import { API_URL, AUTH_TOKEN } from '../../Context';
import axios_api from '../../Api';
import { validateSchemaComprehensive } from './utils/schemaValidation';
import { validateUiSchemaComprehensive } from './utils/uiSchemaValidation';
import ValidationPanel from './components/ValidationPanel';
//import { blood_schema } from '../FormBlood/FormBloodSchema';
//import { blood_uiSchema } from '../FormBlood/FormBloodUiSchema';
//import { blood_formData } from '../FormBlood/FormBloodData';


function FormBuilder() {

  const api_url = useContext(API_URL);
  const token = useContext(AUTH_TOKEN);

  const [loading, setLoading] = useState(true);
  const [formHasCoreParams, setFormHasCoreParams] = useState(false)
  const [editAssetsCalled, setEditAssetsCalled] = useState(false)
  const [activeTab, setActiveTab] = useState('editor');
  const [isDirty, setIsDirty] = useState(false);

  //const [schema, setSchema] = useState(blood_schema);
  //const [data, setData] = useState(blood_formData);
  //const [uiSchema, setUiSchema] = useState(blood_uiSchema);
  const [uiSchema, setUiSchema] = useState({});
  const [schema, setSchema] = useState({});
  const [data, setData] = useState({});
  const [formMetadata, setFormMetadata] = useState({});
  
  // Состояние для ошибок валидации
  const [validationErrors, setValidationErrors] = useState({
    schema: { errors: [], warnings: [] },
    uiSchema: { errors: [], warnings: [] }
  });
  const [hasValidationErrors, setHasValidationErrors] = useState(false);

  let apiReturnedForm = {}
  let { formId } = useParams();
  formId = Number(formId);


  React.useEffect(() => {

    let form = axios_api.get(api_url + '/manage_form/' + formId, {
      headers: {"Authorization": token}
    });

    form.then(
      (result) => {
        apiReturnedForm = result.data;
        //console.log(apiReturnedForm)
        setUiSchema(apiReturnedForm.form_ui_schema)
        setSchema(apiReturnedForm.form_schema)
        setData(apiReturnedForm.form_initial_data)
        let newformMetadata = {
          id: apiReturnedForm.id,
          form_code: apiReturnedForm.form_code,
          name: apiReturnedForm.name,
          cycle: apiReturnedForm.cycle,
          year: apiReturnedForm.year,
          section: apiReturnedForm.section,
          samples_numbers_and_literals: apiReturnedForm.samples_numbers_and_literals,
          form_view_mode: apiReturnedForm.form_view_mode,
          assets: apiReturnedForm.asset_set,
        }
        setFormMetadata(newformMetadata)       
        
        if (apiReturnedForm.section !== "") {
          setFormHasCoreParams(true)
        }
        setLoading(false);
      },
      (error) => {
        console.log(error)
        //setLoading(false);
        //setForms([]);
      }
    );

  }, []);

  // Функции валидации
  const validateSchemas = () => {
    const schemaValidation = validateSchemaComprehensive(schema);
    const uiSchemaValidation = validateUiSchemaComprehensive(uiSchema, schema);
    
    const newValidationErrors = {
      schema: {
        errors: schemaValidation.errors,
        warnings: schemaValidation.warnings
      },
      uiSchema: {
        errors: uiSchemaValidation.errors,
        warnings: uiSchemaValidation.warnings
      }
    };
    
    setValidationErrors(newValidationErrors);
    
    const hasErrors = schemaValidation.errors.length > 0 || uiSchemaValidation.errors.length > 0;
    setHasValidationErrors(hasErrors);
    
    return {
      isValid: !hasErrors,
      errors: newValidationErrors
    };
  };


  // Новая функция для одновременного обновления обеих схем
  const validateAndSetSchemas = (newSchema, newUiSchema) => {
    setSchema(newSchema);
    setUiSchema(newUiSchema);
    
    // Валидируем с новыми данными
    const schemaValidation = validateSchemaComprehensive(newSchema);
    const uiSchemaValidation = validateUiSchemaComprehensive(newUiSchema, newSchema);
    
    const newValidationErrors = {
      schema: {
        errors: schemaValidation.errors,
        warnings: schemaValidation.warnings
      },
      uiSchema: {
        errors: uiSchemaValidation.errors,
        warnings: uiSchemaValidation.warnings
      }
    };
    
    setValidationErrors(newValidationErrors);
    
    const hasErrors = schemaValidation.errors.length > 0 || uiSchemaValidation.errors.length > 0;
    setHasValidationErrors(hasErrors);
  };


  function saveForm () {
    // Валидируем схемы перед сохранением
    const validation = validateSchemas();
    
    if (!validation.isValid) {
      alert('Нельзя сохранить форму с ошибками валидации. Пожалуйста, исправьте ошибки перед сохранением.');
      return;
    }

    let params = {
        form_ui_schema: uiSchema,
        form_schema: schema,
        form_initial_data: data,
        section: formMetadata.section,
        samples_numbers_and_literals: formMetadata.samples_numbers_and_literals,
    };

    //console.log(params)

    axios_api.put(api_url + `/manage_form/` + formMetadata.id, params, {
      headers: {
        "Authorization": token, 
        //"Content-Type": "application/json",
      }
    })
    .then(
      (result) => {
        console.log("Form saved");
        setIsDirty(false);
        // Очищаем ошибки валидации после успешного сохранения
        setValidationErrors({
          schema: { errors: [], warnings: [] },
          uiSchema: { errors: [], warnings: [] }
        });
        setHasValidationErrors(false);
      },
      (error) => {
        console.log(error);
        alert('Ошибка при сохранении формы: ' + (error.response?.data || error.message));
      }
    );
  }

  //console.log(formMetadata.samples_letters)
  //alert(formMetadata.samples_letters.toString())

  return( loading ? 
    (
      <Loader/>
    ) : (
      formHasCoreParams ? (
        editAssetsCalled ? 
          <>
            <FormEditAssets
              formData={formMetadata}
              setFormData={setFormMetadata}
            />
          </>
        :
          <>
            <div className="row">
              <h3 className="m-3 me-5">{formMetadata.name} - {formMetadata.form_code}</h3>
            </div>
            <div className='row me-5'>  
              <div className='col-10'>

                <div className="d-flex justify-content-start align-items-center">
                  <span className='ms-3 m-1 editor-button' style={{position: "relative", top: "0px"}} onClick={() => setFormHasCoreParams(false)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                      <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                      <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"/>
                    </svg>
                  </span>
                  <span className='fw-medium fsvok2-text'>  
                    параметры
                  </span>                
                  <span className='ms-3'>  
                    section: <span className='fw-normal fsvok2-text'>{formMetadata.section} </span>
                  </span>
                  { formMetadata.samples_numbers_and_literals?.length > 0 ?
                    <span className='ms-3'>                   
                      образцы и литералы: {formMetadata.samples_numbers_and_literals?.map((x) => (
                        <span className='small lk-bordered-label fw-normal fsvok2-text m-1 p-1'>{x[0] + ': ' + x[1]}</span>
                      ))}
                    </span>
                  :
                    <></>
                  }
                </div>

                <div className="d-flex justify-content-start align-items-center">
                  <span className='ms-3 m-1 editor-button' style={{position: "relative", top: "0px"}} onClick={() => setEditAssetsCalled(true)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                      <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                      <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"/>
                    </svg>
                  </span>
                  <span className='fw-medium fsvok2-text'>  
                    материалы формы
                  </span>
                  {/** formMetadata.assets */}

                </div>

              </div>
              <div className='col-2 p-0'>
                <div className="d-flex justify-content-end mb-3">

                  {/** 
                    <button
                      className="btn lk-button me-3"
                      onClick={() => validateSchemas()}
                    >
                      Проверить структуру формы
                    </button>
                  */}
                  
                  <button
                    className={`btn ${hasValidationErrors ? 'btn-danger' : 'lk-button'}`}
                    onClick={() => saveForm()}
                    disabled={isDirty === false ? true : false}
                    title={hasValidationErrors ? 'Есть ошибки валидации' : ''}
                  > 
                    {hasValidationErrors ? '⚠️ Ошибки валидации' : 'сохранить форму'}
                  </button>
                </div>
              </div>
            </div>

            {/* Панель валидации */}
            <div className="row ms-3 me-5">
              <ValidationPanel 
                validationErrors={validationErrors}
                hasValidationErrors={hasValidationErrors}
                onValidate={validateSchemas}
              />
            </div>
            
            <div className="row ms-3 me-5 mt-3">
              <ul className="nav nav-tabs">
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === 'editor' ? 'active' : ''}`}
                    onClick={() => setActiveTab('editor')}
                  >
                    Редактирование
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === 'table' ? 'active' : ''}`}
                    onClick={() => setActiveTab('table')}
                  >
                    Таблица
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === 'export' ? 'active' : ''}`}
                    onClick={() => setActiveTab('export')}
                  >
                    Параметры выгрузки
                  </button>
                </li>            
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === 'preview' ? 'active' : ''}`}
                    onClick={() => setActiveTab('preview')}
                  >
                    Превью формы
                  </button>
                </li>
              </ul>
              {activeTab === 'editor' ? 
                <EditorTab
                  schema={schema}
                  data={data}
                  uiSchema={uiSchema}
                  //schema={schema}
                  //uiSchema={uiSchema}
                  validateSchemas={validateSchemas}
                  setSchemas={validateAndSetSchemas}
                  setData={setData}
                  setIsDirty={setIsDirty}
                />
              : 
                <></>
              }
              {activeTab === 'table' ? 
                <TableTab
                  schema={schema}
                  data={data}
                  setSchema={setSchema}
                  setData={setData}
                  setIsDirty={setIsDirty}
                />
              : 
                <></>
              }
              {activeTab === 'export' ? 
                <>
                  <ExportTab
                    schema={schema}
                    data={data}
                    samples_numbers_and_literals={formMetadata.samples_numbers_and_literals}
                    setSchema={setSchema}
                    setData={setData}
                    setIsDirty={setIsDirty}
                  />
                </>
              : 
                <></>
              }    
              {activeTab === 'preview' ? 
                <>
                  <PreviewTab
                    schema={schema}
                    uiSchema={uiSchema}
                    formViewMode={formMetadata.form_view_mode}
                    formData={data} // This is initial form data
                  />
                </>
              : 
                <></>
              }                
            </div>
          </>
        
      ) : (
        <>
          <FormEditParams
            formData={formMetadata}
            setFormData={setFormMetadata}
          />
        </>        
      )
    )
  );
}

export default FormBuilder